
import Vue from "vue";
import AppFileUpload from "../FileUploadDropAndProgress.vue";
import { AuthService } from "../../services/auth-service";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { Tier } from "../../utils/payments/tiers";
import {CarCSVImportExistingCarHandling, CarService} from "@/services/car-service";
import { ISelectItem } from "winfakt-vue-components";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";

export default Vue.extend({
	data() {
		return {
			file: null as null | File,
			uploading: false,
			existingCarHandling: CarCSVImportExistingCarHandling.UPDATE,
		};
	},
	computed: {
		isAllowed():boolean {
			return AuthService.wfCompany.Tier == Tier.ENTERPRISE;
		},
		allowedExtensions():string[] {
			return ["csv", "txt", "xls", "xlsx", "ods"];
		},
		existingCarHandlingItems():ISelectItem<CarCSVImportExistingCarHandling>[]{
			return getEnumKeys(CarCSVImportExistingCarHandling).map(k=>{
				let value =getEnumValueFromKey(CarCSVImportExistingCarHandling, k);
				return {
					text: this.$ct(`csv-import-existing-car-handling.${k}`),
					value,
				} as ISelectItem<CarCSVImportExistingCarHandling>;
			});
		},
		isExcel():boolean {
			if (!this.file) return false;
			return this.file.type.toLowerCase().startsWith("application/");
		}
	},
	methods: {
		cancel() {
			this.$emit("close");

		},
		async upload() {
			if (!this.file) {
				return;
			}
			this.uploading = true;
			try {
				if (this.isExcel){
					var job = await CarService.importCarsExcel(this.file,this.existingCarHandling);
				}else{
					var job = await CarService.importCarsCSV(this.file,this.existingCarHandling);
				}
				this.$wf.notify(this.$ct("import-started"), "info", 3000, "info-circle");
				this.$emit("job", job);
				this.$emit("close");
			} catch (err) {

			}
			this.uploading = false;
		},
	},
	components: {
		AppFileUpload,
		AppMissingModule
	},
	i18nEx: {
		componentPrefix: "components.cars"
	}
});
